<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-card :loading="loading" class="rounded-lg">
          <v-toolbar color="#f8f9fb" elevation="0">
            <v-toolbar-title>{{ $t("faq.title") }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              class="primary"
              @click="$router.push({ name: 'superadminFaqsAdd' })"
            >
              <v-icon left> mdi-plus </v-icon>
              {{ $t("faq.buttons.add") }}
            </v-btn>
          </v-toolbar>
          <v-divider></v-divider>

          <v-card-text style="background-color: #f4f5f7">
            <v-data-table
              :headers="headers"
              :items="faqs"
              :search="search"
              class="elevation-3"
            >
              <template v-slot:top>
                <v-text-field
                  v-model="search"
                  label="Search"
                  append-icon="mdi-magnify"
                  single-line
                  hide-details
                  clearable
                  class="col-md-6"
                ></v-text-field>
              </template>
              <template v-slot:item.created_at="{ item }">
                {{ dateFormatter(item.created_at) }}
              </template>

              <template v-slot:item.actions="{ item }">
                <v-icon size="large" class="mr-2" @click="$router.push(`/superadmin/faqs/edit/${item.id}`)">
                  mdi-pencil
                </v-icon>
                <v-icon size="large" @click="confirmDelete(item.id)">
                  mdi-delete
                </v-icon>
              </template>
            </v-data-table>
          </v-card-text>

          <!-- Delete Confirmation Dialog -->
          <v-dialog v-model="dialogDelete" max-width="450" persistent>
            <v-card>
              <v-card-title class="text-h5 grey lighten-2">
                {{ $t("faq.delete.title") }}
              </v-card-title>
              <v-card-text class="mt-4">
                {{ $t("faq.delete.message") }}
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions class="justify-end">
                <v-btn color="red" text @click="deleteFaq" :loading="saving">
                   {{ $t("yes") }}
                </v-btn>
                <v-btn color="primary" text @click="dialogDelete = false">
                   {{ $t("no") }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapMutations } from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      faqs: [],
      loading: false,
      saving: false,
      search: "",
      dialogDelete: false,
      deletingItemId: null,
      headers: [
        { text: this.$t("faq.headers.question"), value: "question", width: "40%" },
        { text: this.$t("faq.headers.answer"), value: "answer", width: "40%" },
        { text: this.$t("faq.headers.date"), value: "created_at", align: "center" },
        { text: this.$t("faq.headers.actions"), value: "actions", sortable: false, align: "center" },
      ],
    };
  },

  methods: {
    ...mapMutations("alert", ["setAlert"]),

    getFaqs() {
      this.loading = true;
      this.$axios
        .get("superadmin/faqs")
        .then((response) => {
          this.loading = false;
          if (response.data.status) {
            this.faqs = response.data.faqs;
          } else {
            this.showAlert(response.data.message, "red accent-3");
          }
        })
        .catch((error) => {
          this.loading = false;
          console.error(error);
          this.showAlert("Failed to fetch FAQs", "red accent-3");
        });
    },

    dateFormatter(date) {
      return moment(date).format("DD/MM/YYYY");
    },

    confirmDelete(id) {
      this.deletingItemId = id;
      this.dialogDelete = true;
    },

    deleteFaq() {
      this.saving = true;
      this.$axios
        .delete(`superadmin/faqs/${this.deletingItemId}`)
        .then((response) => {
          this.saving = false;
          this.dialogDelete = false;
          if (response.data.status) {
            this.showAlert(response.data.message, "green accent-4");
            this.getFaqs();
          } else {
            this.showAlert(response.data.message, "red accent-3");
          }
        })
        .catch((error) => {
          this.saving = false;
          this.dialogDelete = false;
          console.error(error);
          this.showAlert("Failed to delete FAQ", "red accent-3");
        });
    },

    showAlert(message, variant) {
      this.setAlert({
        showAlert: true,
        variant: variant,
        timeout: "2000",
        message: message,
      });
    },
  },

  mounted() {
    this.getFaqs();
  },
};
</script>

<style scoped>
</style>
